import { AppContext } from "@lightspeed-invoicing/core-client/frontend";
import React, { Component } from 'react';
import { defineMessages, FormattedMessage, injectIntl } from "react-intl";
import Select from 'react-select';
import CreditMemoTypeIcon from "../invoice/creditmemotypeicon.component.jsx";

const messages = defineMessages({
    select_credit_memo: {
        id: 'invoice.credit_memo_select.default_label',
        defaultMessage: 'Select the credit memo to apply',
    },
    no_applicable_credit_memo_found: {
        id: 'invoice.credit_memo_select.no_applicable_credit_memo_found_label',
        defaultMessage: 'No applicable credit memo was found',
    },
    select_deposit: {
        id: 'invoice.deposit_select.default_label',
        defaultMessage: 'Select the deposit to apply',
    },
    no_applicable_deposit_found: {
        id: 'invoice.credit_memo_select.no_applicable_deposit_found_label',
        defaultMessage: 'No applicable deposit was found',
    },
    fetching_data: {
        id: 'invoice.credit_memo_select.fetching_label',
        defaultMessage: 'Fetching...',
    }
})
class DepositCreditMemoSelect extends Component {

    constructor(props, context) {
        super(props, context)

        this.state = {
            className: this.props.className || '',
            onChange: this.props.onChange || function () { },
            invoice: this.props.invoice || null,
            object: this.props.object || null,
            contactId: this.props.contactId || '',
            creditMemos: [],
            creditMemoId: this.props.creditMemoId || '',
            disabled: this.props.disabled || false,
            creditMemoAmount: 0,
            options: [{
                value: "",
                label: <span>{this.props.intl.formatMessage(messages.fetching_data)}</span>,
            }],
            mustCoverFullAmount: this.props.mustCoverFullAmount || false,
            initialAmount: this.props.initialAmount || '0',
            error: '',
            //if true: show only deposits; if false: show all except deposits
            onlyDeposit: this.props.onlyDeposit || false,
            depositTransactions: this.props.depositTransactions || [],
            depositLinkType: this.props.depositLinkType || '',
            depositPayableObject: this.props.depositPayableObject || null,
            orderReferenceId: this.props.orderReferenceId || '',
        }
        const defaultCallback = () => { }
        this.onChange = this.props.onChange || defaultCallback
        this.handleChange = this.handleChange.bind(this)
        this.loadNextDepositLinkType = this.props.loadNextDepositLinkType || defaultCallback
    }

    getFilterFieldByDepositLinkType() {
        switch (this.state.depositLinkType) {
            case 'quotes': return 'quoteReferenceId'
            case 'orders': return 'orderReferenceId'
            case 'price-lists': return 'priceListReferenceId'
            default: return ''
        }
    }

    getDepositsDetachedPaymentIds() {
        return this.state.depositPayableObject?.attributes.paymentTransactions.filter(t => t.attributes.deleted === true ).map(t => t.attributes.paymentId) 
    }

    getDepositInclusionCondition(creditMemo, referenceId, fieldToFilter) {
        //Exclude credit memos whose id matches the corresponding reference type id 
        //(whith the exception of credit memos that have been detached from current document, which we can include)
        //Also exclude credit memos that have another reference from a different type (credit with a reference to a quote and order at the same time for example)
        
        const referenceFields = ["quoteReferenceId", "orderReferenceId"].filter(f => f !== fieldToFilter)

        const hasBeenDetachedFromDocument = this.getDepositsDetachedPaymentIds()?.includes(creditMemo.attributes.paymentId)
        const hasAttachedReferenceId = creditMemo.attributes[fieldToFilter] === referenceId
        const hasAttachedReferenceToOtherField = referenceFields.filter(field => creditMemo.attributes[field]).length > 0
        const isEligible = (!hasAttachedReferenceId && !hasAttachedReferenceToOtherField)

        return hasBeenDetachedFromDocument || isEligible
    }

    filterEligibleDeposits(data) {

        const fieldToFilter = this.getFilterFieldByDepositLinkType()
        
        let creditMemos

        if (fieldToFilter) {
            creditMemos = data.filter(cm => cm.attributes[fieldToFilter] &&
                (this.state.depositPayableObject ? this.getDepositInclusionCondition(cm, this.state.depositPayableObject.id, fieldToFilter) : true))
        } else {
            creditMemos = data.filter(cm => !cm.attributes.quoteReferenceId && !cm.attributes.orderReferenceId)
        }

        creditMemos = creditMemos.filter(cm => {
            const paidTransactionFound = this.state.depositTransactions.find(t => t.attributes.status === 'paid' && !t.attributes.deleted &&
                t.attributes.creditMemoId === cm.id)
            return !paidTransactionFound
        })

        return creditMemos
    }

    componentDidMount() {
        if (!this.state.contactId) {
            return
        }

        let endpoint = `/contacts/${this.state.contactId}/credit-memos`
        if (this.state.orderReferenceId && this.state.depositLinkType === 'price-lists') {
            endpoint = `/orders/${this.state.orderReferenceId}/credit-memos`
        }

        AppContext.getApiClient().get(endpoint).then(res => {
            const creditMemos = this.filterEligibleDeposits(res.data)

            const cmp = (a, b) => (a > b) - (a < b)
            creditMemos.sort(function (a, b) {
                return cmp(a.attributes.notes, b.attributes.notes) || cmp(a.attributes.identifier, b.attributes.identifier)
            })
            
            this.setState({
                creditMemos,
            })
            let options = [{
                value: "",
                label: this.props.intl.formatMessage(creditMemos.length > 0 ? (!this.state.onlyDeposit ? messages.select_credit_memo : messages.select_deposit) :
                    (!this.state.onlyDeposit ? messages.no_applicable_credit_memo_found : messages.no_applicable_deposit_found)),
                amount: 0,
            }]
            for (let creditMemo of creditMemos) {
                options.push({
                    value: creditMemo.id,
                    label: <span><CreditMemoTypeIcon
                        value={creditMemo.attributes.type}
                        className={'mr-1 pb-0'} /> {creditMemo.attributes.identifier} {creditMemo.attributes.notes ? ' - ' + creditMemo.attributes.notes : ''}
                        &nbsp;({this.props.intl.formatNumber((!this.state.depositPayableObject || !this.state.onlyDeposit) ? creditMemo.attributes.remainingAmount : creditMemo.attributes.amount, {
                            style: 'currency',
                            currency: creditMemo.attributes.currency,
                        })})</span>,
                    amount: ((!this.state.depositPayableObject) || !this.state.onlyDeposit) ? creditMemo.attributes.remainingAmount : creditMemo.attributes.amount,
                })
            }
            this.setState({ options }, () => {
                if (this.state.mustCoverFullAmount) {
                    return
                }

                if (this.state.invoice && this.state.invoice.attributes[this.getFilterFieldByDepositLinkType()]) {
                    const creditMemo = this.state.creditMemos.find(cm => {
                        return cm.attributes[this.getFilterFieldByDepositLinkType()] === this.state.invoice.attributes[this.getFilterFieldByDepositLinkType()]
                    })
                    if (creditMemo) {
                        this.setState({
                            creditMemoId: creditMemo.id,
                        }, () => {
                            let amountToApply = parseFloat(creditMemo.attributes.remainingAmount)
                            const balance = parseFloat(this.state.invoice.attributes.balance)
                            if (amountToApply > balance) {
                                amountToApply = this.state.invoice.attributes.balance
                            } else {
                                amountToApply = amountToApply.toString()
                            }
                            amountToApply = amountToApply.toString()
                            this.onChange(this.state.creditMemoId, amountToApply)
                        })
                    } else {
                        this.onChange('', 0)
                    }
                }

                if (this.state.options.length === 2) {
                    this.handleChange(this.state.options[1])
                }
            })

            if (this.loadNextDepositLinkType && this.state.options === 1) {
                this.loadNextDepositLinkType()
                return
            }
        })
    }

    handleChange(selectedOption) {
        let amountToApply = selectedOption ? parseFloat(selectedOption.amount) : 0
        let balance = 0

        if (this.state.invoice) {
            balance = parseFloat(this.state.invoice.attributes.balance)
        } else if (this.state.depositPayableObject) {
            balance = parseFloat(this.state.depositPayableObject.attributes.depositBalance)
            if (balance <= 0) {
                balance = parseFloat(this.state.depositPayableObject.attributes.balance)
            }
        } else if (this.state.mustCoverFullAmount) {
            balance = parseFloat(this.state.initialAmount)
            if (amountToApply < balance) {
                this.setState({
                    error: <small className="text-danger"><FormattedMessage
                        id="invoice.credit_memo_select.not_enough_credit.error"
                        defaultMessage="The remaining amount on this credit memo is not enough to cover the payment of all the invoices"
                    /></small>
                })
            } else {
                this.setState({ error: '' })
            }
        }

        if ((!this.state.depositPayableObject || this.state.depositLinkType !== this.state.depositPayableObject.type) && amountToApply > balance) {
            amountToApply = balance.toString()
        } else {
            amountToApply = amountToApply.toString()
        }
        this.setState({
            creditMemoId: selectedOption ? selectedOption.value : '',
            creditMemoAmount: amountToApply,
        }, () => {
            this.onChange(this.state.creditMemoId, this.state.creditMemoAmount)
        });
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            invoice: nextProps.invoice || null,
            object: nextProps.object || null,
            contactId: nextProps.contactId || '',
            depositPayableObject: nextProps.depositPayableObject || null,
        })
    }

    render() {
        return [this.state.error,
        <Select
            name={this.state.creditMemoId}
            value={this.state.creditMemoId}
            onChange={this.handleChange}
            options={this.state.options}
        />]
    }
}

export default injectIntl(DepositCreditMemoSelect)


// WEBPACK FOOTER //
// ./src/invoice/depositcreditmemoselect.component.jsx